import React, { Component } from 'react'
 class UstoUp extends React.Component{
    render(){
        return(
            <div>
                <p>UstoUp</p>
            </div>
        );
    }
 }

 export default UstoUp; 